import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:space-between;
  flex-wrap:nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Title = styled.div`
  display: flex;
  align-items:center;
  justify-content:center;
  width: 100%;
  font: var(--title);
`;

export const Description = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  font: var(--body);
  p{
    padding-left: 1rem;
  }
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font: var(--body);
`;

export const Link = styled.a``;

export const Tag = styled.span`
  margin-left: 1rem;
  padding: 0.2rem 0.4rem;
  background-color: var(--softBlue);
  border-radius: 0.6rem;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
`;

export const Text = styled.div`
 display: flex;
 flex-direction:row;
 align-items:flex-start;
 justify-content:flex-start;
 flex-wrap:wrap;
 margin-bottom: 0.5rem;
 width: 100%;
 font: var(--body);
 img {
  margin-left: 1rem;
  max-width: 5rem;
 }
 
 @media (max-width: 600px) {}
 @media (max-width: 768px) {}
 @media (max-width: 992px) {}
 @media (max-width: 1200px) {}
`;

export const Ability = styled.ul`
 display: flex;
 flex-direction:row;
 align-items:flex-start;
 justify-content:flex-start;
 flex-wrap:wrap;
 margin-left: 7rem;
 margin-bottom: 0.5rem;
 font: var(--body);
 
 @media (max-width: 600px) {}
 @media (max-width: 768px) {}
 @media (max-width: 992px) {}
 @media (max-width: 1200px) {}
`;


export const Image = styled.div`
 display: flex;
 flex-direction:row;
 align-items:center;
 justify-content:center;
 flex-wrap:wrap;
 max-width: 70rem;
 max-height: 70rem;
 margin-bottom: 0.5rem;
 font: var(--body);
 img {
  max-width: 100%;
  max-height: 100%;
 }
 
 @media (max-width: 600px) {}
 @media (max-width: 768px) {}
 @media (max-width: 992px) {}
 @media (max-width: 1200px) {}
`;